import axios from "axios";
import React, { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { usePreference } from "../context/UserContext";
import QuizzesModel from "../common/QuizzesModel";
// import "../assets/css/homepage.css";
import { Button, Modal } from "react-bootstrap";
import PayPalModal from "./paypal/PaypalModel";
import SubscribeButton from "./SubscribeButton";
import Swal from "sweetalert2";
import {
  Facebook,
  Instagram,
  Twitter,
  LinkedIn,
  Pinterest,
} from "@mui/icons-material";
import imageUrl from "../assets/img/aaa.png"; // Import the local image
import DescriptionComponent from "./DescriptionComponent";
import SpellingLoader2 from "../common/SpellingLoader2";
import ComingSoon from "../common/ComingSoon";
import ShowCart from "./ShowCart";
import TTSTest from "../common/TTSTest";
import AdvertisementModel from "../common/AdvertisementModel";
import LandingPage from "./login/LandingPage";
// import VenmoCheckout from "./paypal/VenmoCheckout";
import BEE from "../assets/img/placeholderImage3.png";
import useTrackFirstVisit from "../common/UseTrackFirstVisit";
import BeeFlyAround from "../common/BeeFlyAround";
import BeeFlyArround2 from "../common/BeeFlyArround2";

const NewContent = ({ highlightedFreePacks, highlightedPurchasePacks,onDataLoaded }) => {
  // //console.log(highlightedFreePacks)
  const [data, setData] = useState([]);
  const [expandedPacks, setExpandedPacks] = useState({});
  const [filteredData, setFilteredData] = useState([]);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState("");

  const username = localStorage.getItem("username");
  const userRole = localStorage.getItem("userrole");
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const style = document.createElement("style");
    style.innerHTML = `
      @keyframes blink {
        0% { opacity: 1; }
        50% { opacity: 0.5; }
        100% { opacity: 1; }
      }
    `;
    document.head.appendChild(style);
  }, []);
  useEffect(() => {
    if (!location.hash) return;

    const id = location.hash.substring(1);

    // Retry scrolling until element is available (in case it's loaded async)
    const tryScroll = (attempt = 0) => {
      const el = document.getElementById(id);
      if (el) {
        el.scrollIntoView({ behavior: "smooth" });
      } else if (attempt < 10) {
        // Retry after a delay (e.g., for async data rendering)
        setTimeout(() => tryScroll(attempt + 1), 300);
      }
    };

    tryScroll();
  }, [location]);
  const togglePackVisibility = (packId) => {
    setExpandedPacks((prev) => ({
      ...prev,
      [packId]: !prev[packId], // Toggle visibility
    }));
  };
  const {
    updateIsNavVisible,
    showCart,
    updateShowCart,
    cart,
    updateCart,
    isMaintenanceOpen,
    updateIsMaintenanceOpen,
    isMaintenanceData,
    updateIsMaintenanceData,
  } = usePreference();

  const updateQuizId = (value) => {
    navigate(`/playquiz/${value}`);
  };
  const addToCart = (pack, type, price, isCollection, action, packname) => {
    updateShowCart(true);

    // Ensure cart is initialized as an empty array if it's not already
    updateCart((prevCart) => {
      const currentCart = Array.isArray(prevCart) ? prevCart : [];

      if (action === "add") {
        // Check if the item (either collection or category) is already in the cart
        const itemAlreadyInCart = currentCart.some(
          (item) =>
            item.packId === pack.Id && item.isCollection === isCollection
        );

        if (itemAlreadyInCart) {
          Swal.fire({
            title: "Info",
            text: "This item is already in your cart.",
            icon: "info",
          });
          return currentCart; // Stop here if the item is already in the cart
        }

        if (isCollection) {
          if (Array.isArray(pack.Categories)) {
            const categoryAlreadyInCart = currentCart.some((item) =>
              pack.Categories.some(
                (category) => item.packId === category.CollectionId
              )
            );

            if (categoryAlreadyInCart) {
              Swal.fire({
                title: "Alert",
                text: "Some categories from this collection are already in your cart. Please remove them first if you wish to add the entire collection.",
                icon: "warning",
              });
              return currentCart;
            }

            // Remove all categories that are part of this collection
            const updatedCart = currentCart.filter(
              (item) =>
                !pack.Categories.some(
                  (category) => item.packId === category.CollectionId
                )
            );
            const newCartItem = {
              pack,
              packId: pack.Id,
              type,
              price,
              isCollection,
              packname: packname,
            };

            const newCart = [...updatedCart, newCartItem];
            localStorage.setItem("cart", JSON.stringify(newCart)); // Save to localStorage
            return newCart;
          }
        } else {
          if (Array.isArray(currentCart)) {
            const collectionInCart = currentCart.some(
              (item) => item.packId === pack.CollectionId
            );

            if (collectionInCart) {
              Swal.fire({
                title: "Alert",
                text: "The collection containing this category is already in your cart. You cannot add individual categories from the collection.",
                icon: "warning",
              });
              return currentCart;
            }
          }

          const newCartItem = {
            pack,
            packId: pack.Id,
            type,
            price,
            isCollection: false,
            packname: packname,
          };

          const newCart = [...currentCart, newCartItem];
          localStorage.setItem("cart", JSON.stringify(newCart)); // Save to localStorage
          return newCart;
        }
      } else if (action === "remove") {
        const updatedCart = currentCart.filter(
          (item) =>
            !(item.packId === pack.Id && item.isCollection === isCollection)
        );
        localStorage.setItem("cart", JSON.stringify(updatedCart)); // Save updated cart to localStorage
        return updatedCart;
      }
    });
  };

  useEffect(() => {
    const targetDate = new Date("2024-12-31");
    const currentDate = new Date();

    // Check if current date is before the target date
    if (currentDate < targetDate) {
      // Check login status using localStorage
      const isLoggedIn = localStorage.getItem("loggedin") === "true"; // Check if logged in

      if (!isLoggedIn) {
        // Non-logged-in users: Show modal only once per day
        // const today = new Date().toISOString().split("T")[0]; // Current date in YYYY-MM-DD format
        // const lastShownDate = localStorage.getItem("modalLastShownDate");

        setIsOpenAdd(true);
      } else {
        // Non-logged-in users: Show modal only once per day
        const today = new Date().toISOString().split("T")[0]; // Current date in YYYY-MM-DD format
        const lastShownDate = localStorage.getItem("modalLastShownDate");

        if (lastShownDate !== today) {
          // Show modal if it hasn't been shown today
          setIsOpenAdd(true);
          localStorage.setItem("modalLastShownDate", today); // Update the last shown date
        } else {
          setIsOpenAdd(false);
        }
      }
    } else {
      // alert("The current date is on or after 16th December 2024!");
      setIsOpenAdd(false);
    }

    fetchMaintenanceData();
  }, []);

  //useTrackFirstVisit();

  // Fetch data from the API
  const fetchMaintenanceData = async () => {
    try {
      const response = await axios.get(
        "https://s3napi.s3nsoftware.com/api/CustomerFeedbacks/Maintenance"
      );
      if (response.data && response.data.length > 0) {
        // If there is any active maintenance window, show the popup
        if (response.data[0].Status === true) {
          updateIsMaintenanceOpen(true);
          updateIsMaintenanceData(response.data);
        }
      }
    } catch (error) {
      console.error("Error fetching maintenance data:", error);
    }
  };

  useEffect(() => {
    function setBackgroundImage(imageUrl) {
      document.body.style.backgroundImage = `url(${imageUrl})`;

      document.body.style.backgroundSize = "cover"; // Ensures the image covers the entire background
      document.body.style.backgroundPosition = "center"; // Centers the image
    }
    // Example usage with a dynamic URL
    // setBackgroundImage(imageUrl);
  }, []);

  useEffect(() => {
    // Update the navigation visibility state
    updateIsNavVisible(true);

    // Function to fetch Free and Paid data based on API type (User/Admin/Anonymous)
    const fetchData = async (freeApiUrl, paidApiUrl) => {
      setLoading(true);
      try {
        // Fetch free packages
        const freeResponse = await axios.get(freeApiUrl);
        const freeData = freeResponse.data;

        // Set free data initially
        setData(freeData); // Set the free data
        setFilteredData(freeData); // Display free data initially

        // Fetch paid packages
        const paidResponse = await axios.get(paidApiUrl);
        const paidData = paidResponse.data;

        // Combine free and paid data
        const combinedData = [...freeData, ...paidData];

        setData(combinedData); // Set the combined data
        setFilteredData(combinedData); // Display all data
        if (onDataLoaded) {
          onDataLoaded(); // ✅ notify LandingPage
        }
      } catch (error) {
        //console.error("Error fetching data:", error);
        setError("Failed to fetch data. Please try again later.");
      } finally {
        setLoading(false); // Stop loading regardless of success or error
      }
    };

    if (username && username.trim()) {
      // If username is available, check user role
      const role = userRole && userRole.trim().toLowerCase(); // Ensure userRole has value and trim spaces

      if (role === "admin" || role === "superadmin") {
        // If user is admin or superadmin, use Admin APIs
        const adminFreeApiUrl = `https://s3napi.s3nsoftware.com/api/QuizDatas/WordPacksInfo/Admin/Free?username=${username}`;
        const adminPaidApiUrl = `https://s3napi.s3nsoftware.com/api/QuizDatas/WordPacksInfo/Admin/Paid?username=${username}`;

        //fetchData(adminFreeApiUrl, adminPaidApiUrl); // Fetch Admin Free and Paid data
        fetchData(adminPaidApiUrl, adminFreeApiUrl); // Fetch Admin Free and Paid data
      } else {
        // If user is not admin/superadmin, use User APIs
        const userFreeApiUrl = `https://s3napi.s3nsoftware.com/api/QuizDatas/WordPacksInfo/User/Free?username=${username}`;
        const userPaidApiUrl = `https://s3napi.s3nsoftware.com/api/QuizDatas/WordPacksInfo/User/Paid?username=${username}`;

        //fetchData(userFreeApiUrl, userPaidApiUrl); // Fetch User Free and Paid data

        fetchData(userPaidApiUrl, userFreeApiUrl); // Fetch User Free and Paid data
      }
    } else {
      // If no username, use Anonymous APIs
      const anonymousFreeApiUrl = `https://s3napi.s3nsoftware.com/api/QuizDatas/WordPacksInfo/Anonymous/Free`;
      const anonymousPaidApiUrl = `https://s3napi.s3nsoftware.com/api/QuizDatas/WordPacksInfo/Anonymous/Paid`;

      // fetchData(anonymousFreeApiUrl, anonymousPaidApiUrl); // Fetch Anonymous Free and Paid data

      fetchData(anonymousPaidApiUrl, anonymousFreeApiUrl); // Fetch Anonymous Free and Paid data
    }
  }, [username, userRole]); // Ensure this effect runs whenever `username` or `userRole` changes

  // Function to handle search
  const handleSearch = (e) => {
    const searchValue = e.target.value.toLowerCase();
    setSearchTerm(searchValue);

    if (searchValue === "") {
      // Show all data when search is cleared
      setFilteredData(data);
    } else {
      const filtered = data
        .map((packs) => {
          // Check if the main package name matches
          if (packs.Package.toLowerCase().includes(searchValue)) {
            return packs; // Return full package if it matches
          }
          // Otherwise, check if any of the categories match
          const matchedCategories = packs.Categories.filter((category) =>
            category.CategoryName.toLowerCase().includes(searchValue)
          );
          // Return only the package with the matched categories if any
          if (matchedCategories.length > 0) {
            return { ...packs, Categories: matchedCategories };
          }
          // Return null if nothing matches
          return null;
        })
        .filter(Boolean); // Remove null values
      setFilteredData(filtered); // Set the filtered data
    }
  };

  const calculatePercentage = (progress) => {
    const [total, correct] = progress.split(",").map(Number); // Split and convert to numbers
    return (correct / total) * 100; // Calculate percentage
  };

  const displayProgressText = (progress) => {
    const [total, correct, wrong] = progress.split(",").map(Number); // Split the progress into total, correct, and wrong
    return `${correct + wrong}/${total}`; // Display correct and wrong answers out of total
    //  return `${correct}/${total} correct, ${wrong}/${total} wrong`; // Display correct and wrong answers out of total
  };

  const [openQuizModel, setOpenQuizModel] = useState(false);
  const [catId, setCatId] = useState(0);
  const [selectedId, setSelectedId] = useState(0);
  const [isCollectionId, setIsCollectionId] = useState(false);
  const [isMonthly, setIsMonthly] = useState(false);
  const [amount, setAmount] = useState(1);
  const [filteredCart, setFilteredCart] = useState([]);
  const updateQuizModel = (value) => {
    setOpenQuizModel(value);
  };

  const [showPaypalModel, setShowPaypalModel] = useState(false); // To manage modal visibility

  const updateShowPaypalModel = (value) => {
    setShowPaypalModel(value);
  };
  // Show the PayPal modal

  useEffect(() => {
    if (cart.length === 0) {
      updateShowCart(false);
    } else {
      // Build a new array with selected fields from the cart
      const filteredCart = cart.map((item) => ({
        packId: item.packId,
        price: item.price,
        isCollection: item.isCollection,
        type: item.type === "monthly" ? true : false,
      }));

      // Do something with the new array, e.g., log it or set it to state
      ////console.log("Filtered Cart:", filteredCart);

      // Optionally, you can save the new array to the state if needed
      setFilteredCart(filteredCart); // Assuming you have a `setFilteredCart` state function
    }
  }, [cart]);

  useEffect(() => {
    const savedCart = localStorage.getItem("cart");
    ////console.log(" cart data ", savedCart);
    if (savedCart) {
      updateCart(JSON.parse(savedCart)); // Load cart from localStorage
    }
  }, []);
  const handleShowMore = (packs) => {
    console.log(packs);
    navigate("/categories", {
      state: {
        subcategories: packs,
        // categoryName: category.Package,
      },
    });
  };

  const [pack, setPack] = useState({});

  const handleClick = (pack) => {
    if (pack.IsLocked) {
      // Show SweetAlert when pack is locked
      Swal.fire({
        icon: "warning",
        text: "Please subscribe for access to the category",
        confirmButtonText: "OK",
      });
    } else {
      // Perform your regular actions when pack is not locked

      navigate(`/playquiz/${pack.Id}`);

      //setCatId(pack.Id);
      //setOpenQuizModel(true);

      //setPack(pack);
      // You can also navigate here if necessary
      // navigate(`/playquiz/${pack.Id}`);
      localStorage.setItem("backgroundimage", pack.CategoryImage);
    }
  };

  // useEffect(()=>{
  //   localStorage.setItem('cart', JSON.stringify([]));
  // updateCart([]);
  // },[])

  // Function to delete an item from the cart
  const deleteItem = (packId, type) => {
    updateCart((prevCart) => {
      // Filter the cart to remove the item
      const updatedCart = prevCart.filter(
        (item) => !(item.packId === packId && item.type === type)
      );

      // Save the updated cart to localStorage
      localStorage.setItem("cart", JSON.stringify(updatedCart));

      // Return the updated cart to update the state
      return updatedCart;
    });
  };

  // Toggle cart visibility
  const toggleCartVisibility = () => {
    //updateCart([]);
    updateShowCart(!showCart);
  };
  const calculateTotal = () => {
    return cart.reduce((sum, item) => sum + item.price, 0).toFixed(2);
  };

  const findCategoryName = (pack, id) => {
    // Find the package by Id
    const foundPack = filteredData.find((pac) => pac.Id === pack.CollectionId);

    // Check if the package and its Categories exist
    if (foundPack && foundPack.Categories) {
      // Find the category by Id
      const category = foundPack.Categories.find((cat) => cat.Id === id);

      // Return the CategoryName if found
      return category ? category.CategoryName : "Unknown Category";
    }

    return "Unknown Category"; // Default if package or category not found
  };

  const { updateIsLoginOpen, updateIsSignUpOpen } = usePreference();

  const handleCheckout = () => {
    const loggedin = localStorage.getItem("loggedin");
    if (loggedin == null || loggedin === "false") {
      Swal.fire({
        icon: "warning",
        text: "Please login or signup to subscribe",
        showCancelButton: true, // Show Cancel button
        showDenyButton: true, // Show Deny button
        confirmButtonText: "Login", // Confirm button text
        denyButtonText: "Sign Up", // Deny button text
        cancelButtonText: "Cancel", // Cancel button text
      }).then((result) => {
        if (result.isConfirmed) {
          // "Login" button clicked
          updateIsLoginOpen(true);
          updateIsSignUpOpen(false);
        } else if (result.isDenied) {
          // "Sign Up" button clicked
          updateIsSignUpOpen(true);
          updateIsLoginOpen(false);
        } else if (result.dismiss === Swal.DismissReason.cancel) {
          // "Cancel" button clicked
          ////console.log("User canceled the action.");
        }
      });

      return;
    }

    // alert("Checkout")
    updateShowPaypalModel(true);
    //setAmount(1);
    setAmount(calculateTotal());
  };

  const scrollToCollection = (index, _) => {
    // Set the search term to the selected package
    setSearchTerm(_.Package);

    // Filter the data to show only the selected package and its categories
    const filtered = data
      .map((packs) => {
        // Check if the package name matches the selected one
        if (packs.Package.toLowerCase() === _.Package.toLowerCase()) {
          return packs; // Return the full package if it matches
        }
        // Otherwise, return null
        return null;
      })
      .filter(Boolean); // Remove null values

    // Set the filtered data to show only the selected package
    setFilteredData(filtered);

    // Optionally scroll to the selected collection (if you want to scroll the page to the filtered section)
  };

  const calculateDaysUntilExpiration = (dateString) => {
    // Parse the date string into a JavaScript Date object
    const expirationDate = new Date(dateString);
    const currentDate = new Date();
    // Calculate the difference in time
    const timeDifference = expirationDate - currentDate;
    // Calculate the difference in days
    const daysUntilExpiration = Math.ceil(
      timeDifference / (1000 * 60 * 60 * 24)
    ); // Convert ms to days
    // Return the number of days, ensure it's not negative
    return daysUntilExpiration > 0 ? daysUntilExpiration : 0;
  };

  function getFormattedPackageName(packageName) {
    const words = packageName
      .replace(/\s+/g, "#*#")
      .split("#*#")
      .filter(Boolean); // Split the string by spaces and remove any empty entries

    if (words.length === 1) {
      // Only one word, take the first 4 characters of the word
      return words[0].slice(0, 4);
    } else {
      // Take the first letter of the first word and enough characters from the last word to make 4 characters
      const firstChar = words[0].charAt(0); // First letter of the first word
      const lastWord = words[words.length - 1]; // Last word

      // Calculate how many characters we need from the last word to make the total length 4
      const remainingChars = lastWord.slice(0, 3); // We need 3 more characters from the last word

      // Combine the first character of the first word with the needed characters from the last word
      return firstChar + remainingChars;
    }
  }

  const [isOpenAdd, setIsOpenAdd] = useState(false);
  const updateOpenAdd = (value) => {
    setIsOpenAdd(value);
  };

  const scrollContainerRefs = useRef({}); // Object to store refs for each scrollable container

  const handleScrollLeft = (id) => {
    const container = scrollContainerRefs.current[id];
    if (container) {
      // Get the first item in the scrollable container
      const firstItem = container.querySelector(".item-align");
      if (firstItem) {
        // Get the computed width of the first item and calculate scroll distance
        const itemWidth = parseFloat(window.getComputedStyle(firstItem).width);
        const gap = parseFloat(window.getComputedStyle(container).gap) || 0; // Extract gap between items
        const scrollDistance = itemWidth + gap;

        // Perform the scroll
        container.scrollBy({
          left: -scrollDistance, // Scroll distance dynamically calculated
          behavior: "smooth",
        });
      } else {
        //console.warn("No .item-align element found inside container.");
      }
    } else {
      //console.warn("No container found with the given ID.");
    }
  };

  const handleScrollRight = (id) => {
    const container = scrollContainerRefs.current[id];
    if (container) {
      // Get the first item in the scrollable container
      const firstItem = container.querySelector(".item-align");
      if (firstItem) {
        // Get the computed width of the first item and calculate scroll distance
        const itemWidth = parseFloat(window.getComputedStyle(firstItem).width);
        const gap = parseFloat(window.getComputedStyle(container).gap) || 0; // Extract gap between items
        const scrollDistance = itemWidth + gap;

        // Perform the scroll
        container.scrollBy({
          left: scrollDistance, // Scroll distance dynamically calculated
          behavior: "smooth",
        });
      } else {
        //console.warn("No .item-align element found inside container.");
      }
    } else {
      //console.warn("No container found with the given ID.");
    }
  };
  // useEffect(() => {
  //   const interval = setInterval(() => {
  //     handleScrollRight();
  //   }, 3000); // Scroll every 3 seconds
  //   return () => clearInterval(interval); // Clear interval on unmount
  // }, []);

  // const handleScrollRight = () => {
  //   scrollContainerRef.current.scrollBy({
  //     left: 300, // Adjust scroll distance as needed
  //     behavior: "smooth", // Smooth scrolling
  //   });
  // };
  const [isPaused, setIsPaused] = useState(false);

  return (
    <>
      {loading ? (
        <div style={{ textAlign: "center", margin: "20px" }}>
          <p>Loading...</p> {/* You can replace with a spinner component */}
        </div>
      ) : (
        <>
          {/* <LandingPage /> */}
          {/* <ComingSoon /> */}
          <BeeFlyAround isPaused={isPaused} />
          <BeeFlyAround isPaused={isPaused} />

          {showCart && (
            <ShowCart
              showCart={showCart}
              toggleCartVisibility={toggleCartVisibility}
              cart={cart}
              deleteItem={deleteItem}
              handleCheckout={handleCheckout}
              calculateTotal={calculateTotal}
              filteredCart={filteredCart}
            />
          )}
          <>
            {" "}
            <div
              style={{
                display: "flex",
                flexWrap: "wrap",
                gap: "20px",
                padding: "20px",
                justifyContent: "center",
              }}
            >
              {filteredData.length > 0 ? (
                filteredData.map((packs, index) => (
                  <div
                    id={packs.IsFree ? "freepack" : "notfreepack"}
                    key={packs.Id}
                    className="pack-card"
                    style={{
                      width:
                        index === 0
                          ? "100%"
                          : window.innerWidth <= 768
                          ? "calc(100% - 20px)"
                          : window.innerWidth <= 1024
                          ? "calc(50% - 20px)"
                          : "calc(33.33% - 20px)", // Responsive widths
                      maxWidth: index === 0 ? "100%" : "350px",
                      display: index === 0 ? "flex" : "block",
                      justifyContent: index === 0 ? "space-around" : "center",
                      boxShadow: "0px 0px 5px rgba(0,0,0,0.2)",
                      backgroundColor:
                        packs.IsFree && highlightedFreePacks
                          ? "#ffff99"
                          : packs.IsFree === false && highlightedPurchasePacks
                          ? "ffff99"
                          : "#fff",
                      borderRadius: "10px",
                      padding: "30px",
                      background: "#fff",
                      border:
                        packs.IsFree && highlightedFreePacks
                          ? "5px solid #ffcc00"
                          : packs.IsFree === false && highlightedPurchasePacks
                          ? "5px solid orange"
                          : "transparent",
                      animation:
                        (packs.IsFree && highlightedFreePacks) ||
                        (packs.IsFree === false && highlightedPurchasePacks)
                          ? "blink 2s 3"
                          : "none",
                    }}
                  >
                    {" "}
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "10px", // Adjust spacing between image and text
                        // zIndex: 2000,
                      }}
                    >
                      {/* <img
                    style={{
                      height: "50px",
                      width: "50px",
                    }}
                    src={BEE}
                    alt="placeholder"
                  /> */}
                      <h5>
                        {packs.Package}
                        {index === 0 && <p>({packs.Discription})</p>}
                        {/* [{getFormattedPackageName(packs.Package)}] */}
                      </h5>
                    </div>
                    {/* <h6>{packs.description}</h6> */}
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "3px",
                      }}
                    >
                      {index !== 0 && (
                        <p style={{ color: "black" }}>
                          (
                          {packs.Categories.reduce(
                            (sum, item) => sum + item.WordCount,
                            0
                          )}{" "}
                          words)
                        </p>
                      )}

                      {packs.IsSubscribed &&
                      packs.DiscountDesc === "Subscribed" ? (
                        <span style={{ color: "green", fontWeight: "bold" }}>
                          Subscribed
                        </span>
                      ) : packs.IsFree == true ? (
                        <span style={{ color: "green", fontWeight: "bold" }}>
                          Always Free
                        </span>
                      ) : (
                        <SubscribeButton
                          packs={packs}
                          buttonWidth={"6%"}
                          addToCart={addToCart}
                          IsCollectionId={true}
                          packname={packs.Package}
                          // style={{ padding: "4px 6px", fontSize: "12px" }}
                        />
                      )}
                    </div>
                    {/* Categories inside the pack */}
                    {packs.Categories.length >= 0 ? (
                      <>
                        <div
                          style={{
                            marginTop: "10px",
                            display: "grid",
                            gridTemplateColumns:
                              window.innerWidth <= 480
                                ? "repeat(1, 1fr)" // Mobile: single column
                                : "repeat(2, 1fr)", // Tablet & Desktop: 2 columns
                            gap: "10px",
                          }}
                        >
                          {packs.Categories.length > 0 &&
                            packs.Categories.slice(0, 4).map((pack) => (
                              <div
                                key={pack.Id}
                                style={{
                                  boxShadow: "0px 0px 3px rgba(0,0,0,0.2)",
                                  borderRadius: "8px",
                                  padding: "5px",
                                  backgroundColor: "#f9f9f9",
                                  cursor: "pointer",
                                  display: "flex",
                                  flexDirection: "column",
                                  alignItems: "center",
                                  width:
                                    window.innerWidth <= 480 ? "100%" : "150px", // Full width on mobile
                                  minWidth: "150px",
                                }}
                                onClick={() => handleClick(pack)}
                              >
                                <div
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    width: "100%",
                                    overflow: "hidden",
                                  }}
                                >
                                  <img
                                    src={pack.CategoryImage}
                                    alt="Category"
                                    style={{
                                      width: "40px",
                                      height: "40px",
                                      borderRadius: "5px",
                                      flexShrink: 0,
                                      marginRight: "5px",
                                    }}
                                  />
                                  <div
                                    style={{
                                      textAlign: "left",
                                      whiteSpace: "nowrap",
                                      overflow: "hidden",
                                      textOverflow: "ellipsis",
                                      maxWidth: "100%",
                                      // display: "flex",
                                    }}
                                  >
                                    {pack.CategoryName.includes("(") ? (
                                      <>
                                        <h6
                                          style={{
                                            fontSize: "10px",
                                            margin: "0",
                                            whiteSpace: "normal",
                                            wordBreak: "break-word",
                                            overflowWrap: "break-word",
                                          }}
                                        >
                                          {pack.CategoryName.split("(")[0]}
                                        </h6>
                                        <h6
                                          style={{
                                            fontSize: "8px",
                                            margin: "0",
                                            wordBreak: "break-word",
                                            overflowWrap: "break-word",
                                          }}
                                        >
                                          ({pack.CategoryName.split("(")[1]}
                                        </h6>
                                      </>
                                    ) : (
                                      <h6
                                        style={{
                                          fontSize: "10px",
                                          margin: "0",
                                          wordBreak: "break-word",
                                          overflowWrap: "break-word",
                                          whiteSpace: "normal",
                                        }}
                                      >
                                        {pack.CategoryName}
                                      </h6>
                                    )}

                                    <h6
                                      style={{ fontSize: "10px", margin: "0" }}
                                    >
                                      <br /> ({pack.WordCount}W)
                                    </h6>
                                  </div>
                                </div>

                                <div
                                  style={{
                                    marginTop: "5px",
                                    display: "flex",
                                    justifyContent: "center",
                                  }}
                                >
                                  {pack.IsFree === true ? (
                                    <span
                                      style={{
                                        color: "green",
                                        fontSize: "10px",
                                        display: "block",
                                      }}
                                    >
                                      Always Free
                                    </span>
                                  ) : pack.IsLocked ? (
                                    <SubscribeButton
                                      packs={pack}
                                      buttonWidth={"50%"}
                                      IsCollectionId={false}
                                      addToCart={addToCart}
                                      packname={pack.CategoryName}
                                    />
                                  ) : (
                                    <span
                                      style={{
                                        color: "green",
                                        fontSize: "10px",
                                        display: "block",
                                      }}
                                    >
                                      Expires in{" "}
                                      {calculateDaysUntilExpiration(
                                        pack.Expired
                                      )}{" "}
                                      days
                                    </span>
                                  )}
                                </div>
                              </div>
                            ))}
                        </div>
                        {packs.Categories.length > 4 && (
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "flex-end",
                              marginTop: "5px",
                            }}
                          >
                            <span
                              className="show-more-text"
                              onClick={() => handleShowMore(packs)}
                              style={{
                                cursor: "pointer",
                                color: "black",
                                textAlign: "right",
                                fontFamily: "sans-serif",
                                fontSize: "12px",
                                fontStyle: "italic",
                                textDecoration: "underline",
                              }}
                            >
                              Info
                            </span>
                          </div>
                        )}
                      </>
                    ) : (
                      <div style={{ marginTop: "10px" }}>
                        <SubscribeButton
                          packs={packs}
                          buttonWidth={"12%"}
                          IsCollectionId={true}
                          addToCart={addToCart}
                          packname={packs.Package}
                        />
                      </div>
                    )}
                  </div>
                ))
              ) : (
                <p>No data found.</p>
              )}
            </div>
          </>

          {openQuizModel ? (
            <QuizzesModel
              open={openQuizModel}
              updateQuizModel={updateQuizModel}
              catId={catId}
              updateQuizId={updateQuizId}
              pack={pack}
            />
          ) : null}

          <PayPalModal
            showPaypalModel={showPaypalModel}
            updateShowPaypalModel={updateShowPaypalModel}
            amount={amount}
            SelectedId={12}
            IsCollectionId={true}
            IsMonthly={true}
            Username={username}
            cartdata={cart}
            filteredCart={filteredCart}
          />

          <AdvertisementModel open={isOpenAdd} updateIsOpen={updateOpenAdd} />
          {/* <footer className="footer">
        <a href="#home" className="to-top-btn">
          <i className="fa fa-arrow-up"></i> To the top
        </a>
        <div className="social-icons">
          <Facebook fontSize="small" />
          <Instagram fontSize="small" />
          <Pinterest fontSize="small" />
          <Twitter fontSize="small" />
          <LinkedIn fontSize="small" />
        </div>
      </footer> */}
        </>
      )}
    </>
  );
};

export default NewContent;
